<template>
  <div class="icon-loader" v-if="loading == true && value == 0"></div>
  <div v-else>
    <span v-if="!Number.isNaN(value)">
      {{ value === 0 || value === "0" ? "-" : value
      }}<span v-if="isPercentage && value !== 0">%</span>
    </span>
    <span v-else>
      -
    </span>
  </div>
</template>
<script>
export default {
  name: "Loader",
  props: ["value", "loading", "isPercentage"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
.icon-loader {
  content: url(../assets/images/loading.gif);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
